/**
 * Permission helpers — single source of truth for what a user can see/do.
 *
 * The backend (auth.py) is authoritative; the frontend just hides UI that the
 * server would reject anyway. NEVER use these as the only enforcement.
 */
import { useAuth } from "../contexts/AuthContext";

export const ALL_PERMISSIONS = [
  "dashboard",
  "fleet",
  "routes",
  "deliveries",
  "finance",
  "contracts",
  "employees",
  "schedule",
  "users",
  "admin",
  "hr",
];

/** True if the user has the given permission key (or is admin). */
export function hasPermission(user, perm) {
  if (!user) return false;
  if (user.role === "admin") return true;
  // Hard deny: drivers must never access the Trasy (planner) app —
  // they only see Zlecenia (formerly Doręczenia).
  if (user.role === "kierowca" && perm === "routes") return false;
  return Array.isArray(user.permissions) && user.permissions.includes(perm);
}

/** Hook variant. */
export function usePermission(perm) {
  const { user } = useAuth();
  return hasPermission(user, perm);
}

/** A user with role 'kierowca' is a driver: they can use the portal for
 *  Trasy / Doręczenia / Grafik only. Other app-menu tiles show up greyed out.
 *  Never returns true for a signed-in kierowca any more — the driver-only
 *  redirect flow is retired now that they have a real dashboard. */
export function isDriverOnly(_user) {
  return false;
}
